import { useDroppable } from '@dnd-kit/core'
import type { ReactNode } from 'react'

import { type KnowledgeFolderItem } from '@/models/knowledgeFolder'
import { FOLDER_DRAG_PREFIX } from './FolderRow'

/**
 * Drop target covering a folder's whole block — its own row and everything
 * nested under it. Scoping it to just the row left the gaps between child rows
 * resolving to the root zone, so a drop onto a document inside a folder moved
 * it to the top level instead.
 */
export function FolderDropZone({
  folder,
  children,
}: {
  folder: KnowledgeFolderItem
  children: (isOver: boolean) => ReactNode
}) {
  const { setNodeRef, isOver } = useDroppable({
    id: `${FOLDER_DRAG_PREFIX}${folder.id}`,
    data: { type: 'folder', folder },
  })

  return <div ref={setNodeRef}>{children(isOver)}</div>
}
